/**
 * Shared vocabulary for the mailbox's quick filters.
 *
 * A quick filter is TRI-state rather than a checkbox: off (the dimension is
 * ignored), positive, or negated. "Starred" and "Not starred" are equally
 * useful for triage, and a two-state toggle can only express one of them —
 * so one click filters, a second inverts, a third clears.
 */

export type FilterTri = 'off' | 'is' | 'not';

export const cycleFilterTri = (v: FilterTri): FilterTri =>
  v === 'off' ? 'is' : v === 'is' ? 'not' : 'off';
